import { FC, Suspense, useCallback, useEffect, useRef, useState } from 'react'
import PortfolioExampleCanvas from '../PortfolioExampleCanvas'
import { VideoContainer, VideoSectionContainer } from './styled'
import { motion } from 'framer-motion'
import DeviceLoadingState from '../PortfolioExampleCanvas/DeviceLoadingState'
import { imageExampleDuration } from './constants'

const ExampleVideo: FC<IExampleVideo> = ({
  currentMedia,
  videoIndex,
  setVideoIndex,
  examplesLength,
  setCurrentMedia,
  examples,
  projectShowcaseVideo,
  projectShowcaseImage,
  defaultDevice,
}) => {
  const [videoLoading, setVideoLoading] = useState(true)
  const videoRef = useRef<HTMLVideoElement | null>(null)

  const isImage = currentMedia === projectShowcaseImage

  useEffect(() => {
    videoRef.current = document.createElement('video')
    videoRef.current.crossOrigin = 'anonymous'
    videoRef.current.loop = false
    videoRef.current.muted = true
    videoRef.current.controls = false
    videoRef.current.autoplay = true
    videoRef.current.playsInline = true
  }, [])

  const handleNextMedia = useCallback(() => {
    if (videoIndex === examplesLength - 1) {
      setCurrentMedia(examples[0].video || projectShowcaseVideo || projectShowcaseImage)
      setVideoIndex(0)
      videoRef?.current?.play()
    } else {
      setCurrentMedia(
        examples[videoIndex + 1].video || projectShowcaseVideo || projectShowcaseImage,
      )
      setVideoIndex(videoIndex + 1)
    }
  }, [
    videoIndex,
    examplesLength,
    setCurrentMedia,
    setVideoIndex,
    examples,
    projectShowcaseVideo,
    projectShowcaseImage,
  ])

  useEffect(() => {
    if (isImage) {
      const imageTimeout = setTimeout(() => {
        handleNextMedia()
      }, imageExampleDuration)

      return () => clearTimeout(imageTimeout)
    } else {
      setVideoLoading(true)

      if (videoRef.current) {
        videoRef.current.onloadeddata = () => {
          setVideoLoading(false)
          videoRef.current?.play()
        }
        videoRef.current.onplay = () => {
          setVideoLoading(false)
        }
        videoRef.current.onended = () => {
          handleNextMedia()
        }
      }
    }
  }, [currentMedia, videoIndex, handleNextMedia, isImage])

  return (
    <VideoSectionContainer>
      <motion.div
        style={{ width: '100%' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2 }}
        key={currentMedia}
      >
        <Suspense fallback={<DeviceLoadingState />}>
          <VideoContainer>
            <PortfolioExampleCanvas
              currentVideo={isImage ? '' : currentMedia}
              currentImage={isImage ? currentMedia : ''}
              videoRef={videoRef}
              examples={examples}
              videoIndex={videoIndex}
              videoLoading={videoLoading}
              defaultDevice={defaultDevice}
            />
          </VideoContainer>
        </Suspense>
      </motion.div>
    </VideoSectionContainer>
  )
}

export default ExampleVideo
